import PageSection from '~/src/features/domru-tv/packages/components/PageSection';
import ServiceCard from '~/src/features/domru-tv/packages/components/ServiceCard';

import { ESectionId } from '../../types';

import { services } from './services';

const Services = ({ sectionId }: { sectionId: ESectionId }): JSX.Element => {
    return (
        <PageSection id={sectionId}>
            <PageSection.Title>Дополнительные услуги</PageSection.Title>
            <PageSection.Content>
                {Object.entries(services).map(([id, service]) => (
                    <ServiceCard
                        key={id}
                        service={service}
                    />
                ))}
            </PageSection.Content>
        </PageSection>
    );
};

export default Services;
